<button pButton pRipple *ngIf="action.type ==='button'" label="{{action.label}}" class="{{action.class}}"
  icon="{{action.icon}}" (click)="ShowEvent(action)"></button>


<!-- Child Components -->
<create-opportunity [visible]="showCreateOpportunityPopup" (hidePopup)="hideOpportunity($event)"></create-opportunity>
<task-create [visible]="showTaskCreate" (hide)="HideTaskCreate($event)"></task-create>
<!-- Child Components -->
